(function () {
  'use strict';

  if (window.__mdcMaisonDouceProductTop) return;
  window.__mdcMaisonDouceProductTop = true;

  var mdcLanguage = ((document.documentElement.lang || (window.Shopify && window.Shopify.locale) || 'fr').toLowerCase().split(/[-_]/)[0]);
  var mdcTranslations = {
    "en": {
      "Description": "Description",
      "Livraison & retours": "Delivery & returns",
      "Garantie": "Warranty",
      "Transporteurs": "Carriers",
      "Votre commande est préparée sous <strong>24 heures ouvrées</strong>, puis livrée sous <strong>6 à 8 jours ouvrés</strong>. Un <strong>numéro de suivi</strong> vous est envoyé <strong>dès l’expédition</strong> afin de suivre votre colis à tout moment.": "See our shipping policy for costs, destinations and estimated delivery times. The conditions applicable to your address are shown before you confirm your order.",
      "Retrouvez le délai pour demander un retour, les frais et la procédure dans notre politique de retour. Vos droits légaux restent applicables.": "See our returns policy for the return request period, costs and procedure. Your statutory rights still apply.",
      "Politique de livraison": "Shipping policy",
      "Politique de retour": "Returns policy",
      "Livraison suivie avec un transporteur partenaire selon votre commande ; retours à nos frais.": "Tracked delivery with a partner carrier depending on your order; we cover return shipping costs.",
      "Les produits bénéficient de la garantie légale de conformité de deux ans lorsqu’elle s’applique. Pour toute question, conservez votre preuve d’achat et contactez notre service client.": "Products benefit from the two-year statutory conformity guarantee where applicable. Keep your proof of purchase and contact customer service if you have any questions.",
      "Contacter Maison Douce": "Contact Maison Douce",
      "Selon le fournisseur, la LED intégrée offre une durée de vie allant jusqu’à 50 000 heures. Aucune ampoule à acheter séparément.": "According to the supplier, the integrated LED has a lifespan of up to 50,000 hours. No bulb needs to be purchased separately.",
      "Un moment de douceur": "A moment of comfort",
      "Un plaid pour vos moments de détente.": "A blanket for your moments of relaxation.",
      "Choisissez votre référence parmi les modèles présentés. Retrouvez les mesures et les détails dans la galerie et la description.": "Choose your reference from the models shown. Find measurements and details in the gallery and description.",
      "Comparez la référence sélectionnée, les mesures et les photos avant d’ajouter votre plaid au panier.": "Compare the selected reference, measurements and photos before adding your blanket to the cart.",
      "Dimensions du plaid": "Blanket dimensions",
      "Consultez les mesures indiquées dans la galerie et la description pour apprécier le format du plaid.": "Check the measurements in the gallery and description to assess the blanket size.",
      "Choix du modèle": "Choosing a model",
      "Les codes FH identifient les différentes références. Sélectionnez un code et vérifiez les photos correspondantes avant de commander.": "FH codes identify the different references. Select a code and check the corresponding photos before ordering.",
      "Contenu de la commande": "Order contents",
      "Vérifiez la référence et la quantité indiquées dans votre panier avant de valider la commande.": "Check the reference and quantity shown in your cart before confirming the order.",
      "Entretien et usage": "Care and use",
      "Pour connaître les consignes d’entretien de la référence choisie, contactez Maison Douce avant de commander.": "Contact Maison Douce before ordering for the care instructions for your selected reference.",
      "Cadeau offert avec votre commande": "Gift included with your order"
    },
    "ar": {
      "Description": "الوصف",
      "Livraison & retours": "التوصيل والإرجاع",
      "Garantie": "الضمان",
      "Transporteurs": "شركات النقل",
      "Votre commande est préparée sous <strong>24 heures ouvrées</strong>, puis livrée sous <strong>6 à 8 jours ouvrés</strong>. Un <strong>numéro de suivi</strong> vous est envoyé <strong>dès l’expédition</strong> afin de suivre votre colis à tout moment.": "اطّلع على سياسة الشحن لمعرفة الرسوم والوجهات ومواعيد التوصيل التقديرية. تُعرض الشروط الخاصة بعنوانك قبل تأكيد الطلب.",
      "Retrouvez le délai pour demander un retour, les frais et la procédure dans notre politique de retour. Vos droits légaux restent applicables.": "تعرّف على مهلة طلب الإرجاع ورسومه وإجراءاته في سياسة الإرجاع. تبقى حقوقك القانونية سارية.",
      "Politique de livraison": "سياسة الشحن",
      "Politique de retour": "سياسة الإرجاع",
      "Livraison suivie avec un transporteur partenaire selon votre commande ; retours à nos frais.": "توصيل مع التتبع عبر شركة نقل شريكة حسب طلبك؛ ونتحمّل رسوم شحن الإرجاع.",
      "Les produits bénéficient de la garantie légale de conformité de deux ans lorsqu’elle s’applique. Pour toute question, conservez votre preuve d’achat et contactez notre service client.": "تستفيد المنتجات من ضمان المطابقة القانوني لمدة سنتين حيثما ينطبق. احتفظ بإثبات الشراء وتواصل مع خدمة العملاء لأي استفسار.",
      "Contacter Maison Douce": "التواصل مع Maison Douce",
      "Selon le fournisseur, la LED intégrée offre une durée de vie allant jusqu’à 50 000 heures. Aucune ampoule à acheter séparément.": "وفقًا للمورّد، يصل العمر التشغيلي لمصباح LED المدمج إلى 50 000 ساعة. لا حاجة لشراء مصباح منفصل.",
      "Un moment de douceur": "لحظة من الراحة",
      "Un plaid pour vos moments de détente.": "بطانية للحظات الاسترخاء.",
      "Choisissez votre référence parmi les modèles présentés. Retrouvez les mesures et les détails dans la galerie et la description.": "اختر المرجع من بين الموديلات المعروضة. تجد المقاسات والتفاصيل في معرض الصور والوصف.",
      "Comparez la référence sélectionnée, les mesures et les photos avant d’ajouter votre plaid au panier.": "قارن المرجع المحدد والمقاسات والصور قبل إضافة البطانية إلى السلة.",
      "Dimensions du plaid": "مقاسات البطانية",
      "Consultez les mesures indiquées dans la galerie et la description pour apprécier le format du plaid.": "راجع المقاسات المذكورة في معرض الصور والوصف لتقييم حجم البطانية.",
      "Choix du modèle": "اختيار الموديل",
      "Les codes FH identifient les différentes références. Sélectionnez un code et vérifiez les photos correspondantes avant de commander.": "تحدّد رموز FH المراجع المختلفة. اختر رمزًا وتحقّق من الصور المقابلة له قبل الطلب.",
      "Contenu de la commande": "محتويات الطلب",
      "Vérifiez la référence et la quantité indiquées dans votre panier avant de valider la commande.": "تحقّق من المرجع والكمية في السلة قبل تأكيد الطلب.",
      "Entretien et usage": "العناية والاستخدام",
      "Pour connaître les consignes d’entretien de la référence choisie, contactez Maison Douce avant de commander.": "تواصل مع Maison Douce قبل الطلب لمعرفة تعليمات العناية بالمرجع المختار.",
      "Cadeau offert avec votre commande": "هدية مع طلبك"
    },
    "es": {
      "Description": "Descripción",
      "Livraison & retours": "Entrega y devoluciones",
      "Garantie": "Garantía",
      "Transporteurs": "Transportistas",
      "Votre commande est préparée sous <strong>24 heures ouvrées</strong>, puis livrée sous <strong>6 à 8 jours ouvrés</strong>. Un <strong>numéro de suivi</strong> vous est envoyé <strong>dès l’expédition</strong> afin de suivre votre colis à tout moment.": "Consulta nuestra política de envío para conocer los gastos, los destinos y los plazos estimados. Las condiciones aplicables a tu dirección se indican antes de confirmar el pedido.",
      "Retrouvez le délai pour demander un retour, les frais et la procédure dans notre politique de retour. Vos droits légaux restent applicables.": "Consulta nuestra política de devoluciones para conocer el plazo, los gastos y el procedimiento. Tus derechos legales siguen siendo aplicables.",
      "Politique de livraison": "Política de envío",
      "Politique de retour": "Política de devoluciones",
      "Livraison suivie avec un transporteur partenaire selon votre commande ; retours à nos frais.": "Entrega con seguimiento mediante un transportista asociado según tu pedido; asumimos los gastos de envío de la devolución.",
      "Les produits bénéficient de la garantie légale de conformité de deux ans lorsqu’elle s’applique. Pour toute question, conservez votre preuve d’achat et contactez notre service client.": "Los productos cuentan con la garantía legal de conformidad de dos años cuando sea aplicable. Conserva el justificante de compra y contacta con atención al cliente si tienes dudas.",
      "Contacter Maison Douce": "Contactar con Maison Douce",
      "Selon le fournisseur, la LED intégrée offre une durée de vie allant jusqu’à 50 000 heures. Aucune ampoule à acheter séparément.": "Según el proveedor, el LED integrado tiene una vida útil de hasta 50 000 horas. No es necesario comprar una bombilla por separado.",
      "Un moment de douceur": "Un momento de suavidad",
      "Un plaid pour vos moments de détente.": "Una manta para tus momentos de descanso.",
      "Choisissez votre référence parmi les modèles présentés. Retrouvez les mesures et les détails dans la galerie et la description.": "Elige tu referencia entre los modelos presentados. Consulta las medidas y los detalles en la galería y la descripción.",
      "Comparez la référence sélectionnée, les mesures et les photos avant d’ajouter votre plaid au panier.": "Compara la referencia seleccionada, las medidas y las fotos antes de añadir la manta al carrito.",
      "Dimensions du plaid": "Dimensiones de la manta",
      "Consultez les mesures indiquées dans la galerie et la description pour apprécier le format du plaid.": "Consulta las medidas de la galería y la descripción para valorar el tamaño de la manta.",
      "Choix du modèle": "Elección del modelo",
      "Les codes FH identifient les différentes références. Sélectionnez un code et vérifiez les photos correspondantes avant de commander.": "Los códigos FH identifican las distintas referencias. Selecciona un código y comprueba las fotos correspondientes antes de hacer el pedido.",
      "Contenu de la commande": "Contenido del pedido",
      "Vérifiez la référence et la quantité indiquées dans votre panier avant de valider la commande.": "Comprueba la referencia y la cantidad indicadas en el carrito antes de confirmar el pedido.",
      "Entretien et usage": "Cuidado y uso",
      "Pour connaître les consignes d’entretien de la référence choisie, contactez Maison Douce avant de commander.": "Contacta con Maison Douce antes de hacer el pedido para conocer las instrucciones de cuidado de la referencia elegida.",
      "Cadeau offert avec votre commande": "Regalo incluido con tu pedido"
    }
  };
  function mdcText(text) {
    var translations = mdcTranslations[mdcLanguage];
    return translations && Object.prototype.hasOwnProperty.call(translations, text) ? translations[text] : text;
  }

  function mdcHtml(html) {
    var translations = mdcTranslations[mdcLanguage];
    if (!translations) return html;
    return Object.keys(translations).sort(function (a, b) { return b.length - a.length; }).reduce(function (value, text) {
      return value.split(text).join(translations[text]);
    }, html);
  }

  var truckIcon = '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M3 6h11v10H3zM14 9h4l3 3v4h-7zM7 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM18 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/></svg>';
  var returnIcon = '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M3 12a9 9 0 1 0 3-6.7L3 8M3 3v5h5"/></svg>';
  var supportIcon = '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M4 13a8 8 0 0 1 16 0v5a2 2 0 0 1-2 2h-3v-6h5M4 14h5v6H6a2 2 0 0 1-2-2v-5"/></svg>';
  var shieldIcon = '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M12 3 5 6v5c0 4.6 2.8 8.6 7 10 4.2-1.4 7-5.4 7-10V6zM9 12l2 2 4-4"/></svg>';
  var giftIcon = '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M4 10h16v10H4zM3 6h18v4H3zM12 6v14M12 6H8.5a2.5 2.5 0 1 1 2.2-3.7L12 6Zm0 0h3.5a2.5 2.5 0 1 0-2.2-3.7L12 6Z"/></svg>';

  function productRoot() {
    return document.querySelector('main [id^="ProductInformation-"]');
  }

  function directContent(root) {
    return root && root.querySelector(':scope > .group-block > .group-block-content');
  }

  function data() {
    var element = document.getElementById('MdcMaisonDouceProductData');
    return element ? element.dataset : {};
  }

  function directChildren(content) {
    return Array.prototype.slice.call(content ? content.children : []);
  }

  function makeAccordion(title, content) {
    var details = document.createElement('details');
    details.className = 'mdc-reference-accordion';
    var summary = document.createElement('summary');
    summary.textContent = mdcText(title);
    var body = document.createElement('div');
    body.className = 'mdc-reference-accordion__content';
    if (typeof content === 'string') body.innerHTML = mdcHtml(content);
    else if (content) body.appendChild(content);
    details.appendChild(summary);
    details.appendChild(body);
    return details;
  }

  function findDescription(content, buy) {
    var children = directChildren(content);
    var buyIndex = children.indexOf(buy);
    for (var i = buyIndex + 1; i < children.length; i += 1) {
      if (children[i].tagName && children[i].tagName.toLowerCase() === 'rte-formatter') return children[i];
    }
    return null;
  }

  function configureWarranty(accordions, buy) {
    var template = buy.querySelector('template[data-mdc-warranty-content]');
    var warranty = accordions.querySelectorAll('details')[2];
    if (!template || !warranty) return;
    warranty.querySelector('summary').textContent = template.dataset.title;
    warranty.querySelector('.mdc-reference-accordion__content').innerHTML = template.innerHTML;
    warranty.dataset.mdcWarranty = 'true';

  }

  var deliveryReturnsContent =
    "<p>Votre commande est préparée sous <strong>24 heures ouvrées</strong>, puis livrée sous <strong>6 à 8 jours ouvrés</strong>. Un <strong>numéro de suivi</strong> vous est envoyé <strong>dès l’expédition</strong> afin de suivre votre colis à tout moment.</p><p>Retrouvez le délai pour demander un retour, les frais et la procédure dans notre politique de retour. Vos droits légaux restent applicables.</p><p><a href=\"/policies/shipping-policy\">Politique de livraison</a> · <a href=\"/policies/refund-policy\">Politique de retour</a></p>" +
    "<div class=\"mdc-delivery-carriers\" role=\"group\" aria-label=\"Transporteurs\">" +
    "<img class=\"mdc-delivery-carrier mdc-delivery-carrier--colissimo\" src=\"https://cdn.shopify.com/s/files/1/0988/6174/4446/files/mdc-colissimo-logo-officiel.png?v=1792230520\" alt=\"Colissimo – La Poste\" width=\"250\" height=\"102\" loading=\"lazy\" decoding=\"async\">" +
    "<img class=\"mdc-delivery-carrier mdc-delivery-carrier--cainiao\" src=\"https://cdn.shopify.com/s/files/1/0988/6174/4446/files/mdc-cainiao-logo-officiel.svg?v=1792230527\" alt=\"Cainiao\" width=\"447\" height=\"246\" loading=\"lazy\" decoding=\"async\">" +
    "<img class=\"mdc-delivery-carrier mdc-delivery-carrier--mondial\" src=\"https://cdn.shopify.com/s/files/1/0988/6174/4446/files/mdc-mondial-relay-logo-officiel.svg?v=1792221118\" alt=\"Mondial Relay by InPost\" width=\"789\" height=\"352\" loading=\"lazy\" decoding=\"async\">" +
    "</div>" +
    "<p>Livraison suivie avec un transporteur partenaire selon votre commande ; retours à nos frais.</p>";

  deliveryReturnsContent = mdcHtml(deliveryReturnsContent);

  function normalizeAccordions(content, buy) {
    var accordions = content.querySelector(':scope > .mdc-reference-accordions');
    var descriptionContent = null;

    if (accordions && accordions.classList.contains('mdc-z-accordions')) return accordions;

    if (accordions) {
      accordions.classList.add('mdc-z-accordions');
      var existingDetails = accordions.querySelectorAll('details');
      if (existingDetails.length >= 3) {
        existingDetails[0].querySelector('summary').textContent = mdcText('Description');
        existingDetails[1].querySelector('summary').textContent = mdcText('Livraison & retours');
        existingDetails[1].querySelector('.mdc-reference-accordion__content').innerHTML =
          deliveryReturnsContent;
        existingDetails[2].querySelector('summary').textContent = mdcText('Garantie');
        existingDetails[2].querySelector('.mdc-reference-accordion__content').innerHTML =
          mdcHtml('<p>Les produits bénéficient de la garantie légale de conformité de deux ans lorsqu’elle s’applique. Pour toute question, conservez votre preuve d’achat et contactez notre service client.</p><p><a href="/pages/contact">Contacter Maison Douce</a></p>');
        configureWarranty(accordions, buy);
        bindAccordions(accordions);
        return accordions;
      }
    } else {
      var description = findDescription(content, buy);
      if (!description) return null;
      descriptionContent = document.createElement('div');
      while (description.firstChild) descriptionContent.appendChild(description.firstChild);
      accordions = document.createElement('div');
      description.replaceWith(accordions);
    }

    accordions.className = 'mdc-reference-accordions mdc-z-accordions';
    accordions.appendChild(makeAccordion('Description', descriptionContent));
    accordions.appendChild(makeAccordion(
      'Livraison & retours',
      deliveryReturnsContent
    ));
    accordions.appendChild(makeAccordion(
      'Garantie',
      mdcHtml('<p>Les produits bénéficient de la garantie légale de conformité de deux ans lorsqu’elle s’applique. Pour toute question, conservez votre preuve d’achat et contactez notre service client.</p><p><a href="/pages/contact">Contacter Maison Douce</a></p>')
    ));

    configureWarranty(accordions, buy);
    bindAccordions(accordions);
    return accordions;
  }

  function configureIntegratedLed(accordions) {
    if (!accordions) return;
    var content = accordions.querySelector('details:first-child .mdc-reference-accordion__content');
    if (!content) return;
    var note = content.querySelector('[data-mdc-integrated-led-note]');
    var message = mdcText(data().integratedLedMessage);
    if (!message) {
      if (note) note.remove();
      return;
    }
    if (!note) {
      note = document.createElement('p');
      note.dataset.mdcIntegratedLedNote = 'true';
      content.prepend(note);
    }
    if (note.textContent !== message) note.textContent = message;
  }

  function bindAccordions(accordions) {
    if (accordions.dataset.mdcZAccordions === 'true') return;
    accordions.dataset.mdcZAccordions = 'true';
    accordions.querySelectorAll('details').forEach(function (details) {
      details.querySelector('summary').addEventListener('click', function (event) {
        if (event.defaultPrevented || !window.matchMedia('(min-width: 750px)').matches) return;
        var summary = event.currentTarget;
        var top = summary.getBoundingClientRect().top;
        var root = accordions.closest('.product-details');
        var grid = root && root.closest('.product-information__grid');
        event.preventDefault();
        details.open = !details.open;
        if (details.open) {
          accordions.querySelectorAll('details[open]').forEach(function (other) {
            if (other !== details) other.open = false;
          });
        }
        if (grid && grid.mdcDesktopScrollController) grid.mdcDesktopScrollController.refresh();
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            if (!summary.isConnected || !window.matchMedia('(min-width: 750px)').matches) return;
            var header = document.querySelector('#header-component');
            var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
            var anchor = details.open ? Math.max(16, headerBottom + 16) : top;
            var remaining = details.open && grid && window.getComputedStyle(root).position === 'sticky'
              ? Math.max(0, grid.getBoundingClientRect().bottom - root.getBoundingClientRect().bottom) : 0;
            var offset = summary.getBoundingClientRect().top - anchor + remaining;
            if (Math.abs(offset) > 1) window.scrollBy({ top: offset, behavior: 'instant' });
            if (details.open) window.requestAnimationFrame(function () {
              if (!summary.isConnected || !details.open || !window.matchMedia('(min-width: 750px)').matches) return;
              var currentHeaderBottom = header ? header.getBoundingClientRect().bottom : 0;
              var overlap = summary.getBoundingClientRect().top - Math.max(16, currentHeaderBottom + 16);
              if (overlap < -1) window.scrollBy({ top: overlap, behavior: 'instant' });
            });
          });
        });
      });
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        accordions.querySelectorAll('details[open]').forEach(function (other) {
          if (other !== details) other.open = false;
        });
      });
    });
  }

  function findBenefits(content, buy, variant) {
    return directChildren(content).find(function (child) {
      return child.tagName && child.tagName.toLowerCase() === 'rte-formatter' && child !== buy && child !== variant;
    }) || null;
  }

  function isPlaidProduct() {
    return /\/products\/cadeau-premium-plaid-polaire-a-manches-140-cm\/?$/.test(window.location.pathname);
  }

  function adaptPlaidPresentation() {
    if (!isPlaidProduct()) return;
    document.body.classList.add('mdc-plaid-product');
    function replaceText(selector, text) {
      text = mdcText(text);
      document.querySelectorAll(selector).forEach(function (element) {
        if (element.textContent !== text) element.textContent = text;
      });
    }
    replaceText('.mdc-product-story__eyebrow', 'Un moment de douceur');
    replaceText('.mdc-product-story__heading', 'Un plaid pour vos moments de détente.');
    replaceText('.mdc-product-story__text', 'Choisissez votre référence parmi les modèles présentés. Retrouvez les mesures et les détails dans la galerie et la description.');
    replaceText('.mdc-product-faq__intro > p:not(.mdc-product-faq__eyebrow)', 'Comparez la référence sélectionnée, les mesures et les photos avant d’ajouter votre plaid au panier.');
    var entries = [
      ['Dimensions du plaid', 'Consultez les mesures indiquées dans la galerie et la description pour apprécier le format du plaid.'],
      ['Choix du modèle', 'Les codes FH identifient les différentes références. Sélectionnez un code et vérifiez les photos correspondantes avant de commander.'],
      ['Contenu de la commande', 'Vérifiez la référence et la quantité indiquées dans votre panier avant de valider la commande.'],
      ['Entretien et usage', 'Pour connaître les consignes d’entretien de la référence choisie, contactez Maison Douce avant de commander.']
    ];
    document.querySelectorAll('.mdc-product-faq__item').forEach(function (item, index) {
      if (!entries[index]) return;
      var heading = item.querySelector('summary > span:first-child');
      var answer = item.querySelector('.mdc-product-faq__answer');
      if (heading && heading.textContent !== mdcText(entries[index][0])) heading.textContent = mdcText(entries[index][0]);
      if (answer && answer.textContent !== mdcText(entries[index][1])) answer.textContent = mdcText(entries[index][1]);
    });
  }

  function populateBenefits(content, accordions, variant, buy) {
    var benefits = content.querySelector(':scope > .mdc-z-benefits');
    var editorialPoints = content.querySelector(':scope > .mdc-pdp-points') ||
      (benefits && benefits.querySelector('.mdc-pdp-points'));

    if (!benefits) {
      benefits = document.createElement('div');
      benefits.className = 'mdc-z-benefits';
      content.insertBefore(benefits, variant || buy);
    }

    if (editorialPoints) {
      if (editorialPoints.parentNode !== benefits) benefits.appendChild(editorialPoints);
      return;
    }

    var productData = data();
    var values = [productData.benefitOne, productData.benefitTwo, productData.benefitThree].filter(Boolean);
    if (values.length !== 3 && accordions) {
      var descriptionItems = Array.prototype.map.call(
        accordions.querySelectorAll('.mdc-reference-accordion:first-child li'),
        function (item) { return item.textContent.trim(); }
      ).filter(Boolean).slice(0, 3);
      if (descriptionItems.length === 3) values = descriptionItems;
    }

    if (values.length === 0) {
      benefits.remove();
      return;
    }

    var signature = values.join('|');
    if (benefits.dataset.mdcZBenefits === signature) return;
    benefits.dataset.mdcZBenefits = signature;
    var list = document.createElement('ul');
    values.forEach(function (value) {
      var item = document.createElement('li');
      item.textContent = value;
      list.appendChild(item);
    });
    benefits.replaceChildren(list);
  }

  var mobileInformationQuery = window.matchMedia('(max-width: 749px)');
  var mobileInformationPositions = new WeakMap();

  function positionMobileInformation(content, header, buy) {
    if (!content || !header || !buy) return;
    var placement = mobileInformationPositions.get(content);
    if (!mobileInformationQuery.matches && !placement) return;

    function restore(entry) {
      if (!entry) return;
      var next = entry.next && entry.next.parentNode === entry.parent ? entry.next : null;
      entry.parent.insertBefore(entry.node, next);
    }

    var lead = header.querySelector('.mdc-pdp-lead');
    var benefits = Array.prototype.find.call(content.querySelectorAll(':scope > .mdc-z-benefits'), function (node) {
      return !placement || !placement.benefits || node !== placement.benefits.node;
    }) || (placement && placement.benefits && placement.benefits.node.parentNode === content ? placement.benefits.node : null);
    if (!placement) {
      placement = {};
      mobileInformationPositions.set(content, placement);
    }
    if (lead && (!placement.lead || placement.lead.node !== lead)) {
      if (placement.lead) placement.lead.node.remove();
      placement.lead = { node: lead, parent: lead.parentNode, next: lead.nextSibling };
    }
    if (benefits && (!placement.benefits || placement.benefits.node !== benefits)) {
      if (placement.benefits) placement.benefits.node.remove();
      placement.benefits = { node: benefits, parent: benefits.parentNode, next: benefits.nextSibling };
    }

    if (!mobileInformationQuery.matches) {
      restore(placement.benefits);
      restore(placement.lead);
      mobileInformationPositions.delete(content);
      return;
    }

    var previous = buy;
    [placement.lead, placement.benefits].forEach(function (entry) {
      if (!entry || !entry.node.isConnected) return;
      if (previous.nextSibling !== entry.node) content.insertBefore(entry.node, previous.nextSibling);
      previous = entry.node;
    });
  }

  function buildPromo(content, header) {
    var promo = content.querySelector(':scope > .mdc-z-promo');
    if (!window.MDCAdvantage) return null;
    if (!promo) {
      promo = document.createElement('div');
      promo.className = 'mdc-z-promo mdc-advantage';
    }
    var review = content.querySelector(':scope > .mdc-store-review-line');
    content.insertBefore(promo, review ? review.nextSibling : header);
    window.MDCAdvantage.render(promo);
    return promo;
  }

  function buildGift(content, buy) {
    var existing = content.querySelector(':scope > .mdc-z-gift');
    var productData = data();
    if (productData.giftEnabled !== 'true') {
      if (existing) existing.remove();
      return null;
    }
    var gift = existing || document.createElement('div');
    gift.className = 'mdc-z-gift';
    var text = mdcText(productData.giftText || 'Cadeau offert avec votre commande').replace(/[<>&]/g, '');
    if (gift.dataset.mdcZGift !== text) {
      gift.dataset.mdcZGift = text;
      gift.innerHTML = giftIcon + '<span>' + text + '</span>';
    }
    if (!gift.parentNode) content.insertBefore(gift, buy);
    return gift;
  }

  function enhanceTrust(buy) {
    var root = buy && buy.closest('[id^="ProductInformation-"]');
    if (root) root.querySelectorAll('.mdc-buy-trust').forEach(function (item) { item.remove(); });
  }

  function bindMobileGallery() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var scroller = gallery.querySelector('slideshow-slides');
      var strip = gallery.querySelector('.slideshow-controls__thumbnails');
      var thumbs = strip && Array.prototype.slice.call(strip.querySelectorAll('.slideshow-controls__thumbnail'));
      if (!scroller || !strip || !thumbs || !thumbs.length) return;
      if (gallery.dataset.mdcZThumbSync === 'true' && gallery.mdcZThumbStrip === strip) return;

      if (gallery.mdcZThumbCleanup) gallery.mdcZThumbCleanup();
      gallery.dataset.mdcZThumbSync = 'true';
      gallery.mdcZThumbStrip = strip;
      var frame = 0;
      var settleTimer = 0;
      var currentIndex = -1;
      var clickHandlers = [];

      function showThumb(index, behavior) {
        index = Math.max(0, Math.min(index, thumbs.length - 1));
        if (currentIndex === index && behavior === 'auto') return;
        var thumb = thumbs[index];
        var width = strip.clientWidth;
        var target = thumb.offsetLeft - ((width - thumb.offsetWidth) / 2);
        var maximum = Math.max(0, strip.scrollWidth - width);
        if (currentIndex !== index) {
          if (currentIndex >= 0) thumbs[currentIndex].classList.remove('is-mdc-current');
          else thumbs.forEach(function (item) { item.classList.remove('is-mdc-current'); });
          thumb.classList.add('is-mdc-current');
          currentIndex = index;
        }
        strip.scrollTo({ left: Math.max(0, Math.min(target, maximum)), behavior: behavior || 'auto' });
      }

      function visibleIndex() {
        return Math.round(scroller.scrollLeft / Math.max(1, scroller.clientWidth));
      }

      function syncSelected(behavior) {
        var selected = thumbs.findIndex(function (thumb) {
          return thumb.getAttribute('aria-selected') === 'true';
        });
        showThumb(selected >= 0 ? selected : visibleIndex(), behavior);
      }

      function onScroll() {
        if (!frame) {
          frame = window.requestAnimationFrame(function () {
            frame = 0;
            showThumb(visibleIndex(), 'auto');
          });
        }
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(function () {
          showThumb(visibleIndex(), 'smooth');
        }, 120);
      }
      scroller.addEventListener('scroll', onScroll, { passive: true });

      thumbs.forEach(function (thumb, index) {
        var onClick = function () { showThumb(index, 'smooth'); };
        clickHandlers.push(onClick);
        thumb.addEventListener('click', onClick);
      });

      var selectionObserver = new MutationObserver(function () {
        syncSelected('smooth');
      });
      selectionObserver.observe(strip, { subtree: true, attributes: true, attributeFilter: ['aria-selected'] });

      gallery.mdcZThumbCleanup = function () {
        scroller.removeEventListener('scroll', onScroll);
        thumbs.forEach(function (thumb, index) { thumb.removeEventListener('click', clickHandlers[index]); });
        selectionObserver.disconnect();
        window.cancelAnimationFrame(frame);
        window.clearTimeout(settleTimer);
      };

      syncSelected('auto');
    });
  }

  var desktopGalleryScrollGrid = null;

  function configureDesktopGalleryScroll(root) {
    var grid = root && root.closest('.product-information__grid');
    if (desktopGalleryScrollGrid && desktopGalleryScrollGrid !== grid) {
      desktopGalleryScrollGrid.mdcDesktopScrollCleanup();
    }
    if (!grid) return;

    var media = grid.querySelector(':scope > .product-information__media');
    var existing = grid.mdcDesktopScrollController;
    if (existing && existing.root === root && existing.media === media) {
      existing.refresh();
      return;
    }
    if (grid.mdcDesktopScrollCleanup) grid.mdcDesktopScrollCleanup();
    if (!media || !root.classList.contains('sticky-content--desktop')) {
      grid.style.removeProperty('--mdc-gallery-scroll-height');
      root.style.removeProperty('--mdc-details-scroll-height');
      return;
    }

    var frame = 0;
    var disposed = false;
    var observer = null;
    var controller = { root: root, media: media, refresh: refresh };
    var mediaStyles = ['position', 'top', 'align-self'].map(function (name) {
      return { name: name, value: media.style.getPropertyValue(name), priority: media.style.getPropertyPriority(name) };
    });

    function restoreMedia() {
      mediaStyles.forEach(function (style) {
        if (style.value) media.style.setProperty(style.name, style.value, style.priority);
        else media.style.removeProperty(style.name);
      });
    }

    function refresh() {
      if (!disposed && !frame) frame = window.requestAnimationFrame(measure);
    }

    function measure() {
      frame = 0;
      if (!grid.isConnected || !root.isConnected || !media.isConnected) {
        cleanup();
        return;
      }
      if (!window.matchMedia('(min-width: 750px)').matches || !root.classList.contains('sticky-content--desktop')) {
        grid.style.removeProperty('--mdc-gallery-scroll-height');
        root.style.removeProperty('--mdc-details-scroll-height');
        restoreMedia();
        return;
      }

      var rootStyle = window.getComputedStyle(root);
      var gridStyle = window.getComputedStyle(grid);
      var cadence = document.querySelector('sticky-add-to-cart[data-product-id="12599821336894"]');
      var top = cadence ? (parseFloat(rootStyle.getPropertyValue('--header-height')) || 0) + 16 : parseFloat(rootStyle.top) || 0;
      var visibleHeight = Math.max(0, window.innerHeight - top - 16);
      var mediaHeight = media.getBoundingClientRect().height;
      var detailsHeight = root.getBoundingClientRect().height;
      if (cadence) root.style.setProperty('--mdc-details-scroll-height', detailsHeight + 'px');
      if (!mediaHeight || !detailsHeight || !visibleHeight) {
        grid.style.removeProperty('--mdc-gallery-scroll-height');
        return;
      }

      var mediaTop = Math.min(top, window.innerHeight - mediaHeight - 16) + 'px';
      if (media.style.getPropertyValue('position') !== 'sticky') media.style.setProperty('position', 'sticky', 'important');
      if (media.style.getPropertyValue('top') !== mediaTop) media.style.setProperty('top', mediaTop, 'important');
      if (media.style.getPropertyValue('align-self') !== 'start') media.style.setProperty('align-self', 'start', 'important');

      var frameHeight = ['paddingTop', 'paddingBottom', 'borderTopWidth', 'borderBottomWidth'].reduce(function (total, name) {
        return total + (parseFloat(gridStyle[name]) || 0);
      }, 0);
      var height = mediaHeight + Math.max(0, detailsHeight - visibleHeight) + frameHeight;
      var value = (Math.ceil(height * 100) / 100) + 'px';
      if (grid.style.getPropertyValue('--mdc-gallery-scroll-height') !== value) {
        grid.style.setProperty('--mdc-gallery-scroll-height', value);
      }
    }

    function cleanup() {
      if (disposed) return;
      disposed = true;
      window.cancelAnimationFrame(frame);
      if (observer) observer.disconnect();
      window.removeEventListener('resize', refresh);
      grid.style.removeProperty('--mdc-gallery-scroll-height');
      root.style.removeProperty('--mdc-details-scroll-height');
      restoreMedia();
      if (grid.mdcDesktopScrollController === controller) {
        delete grid.mdcDesktopScrollController;
        delete grid.mdcDesktopScrollCleanup;
      }
      if (desktopGalleryScrollGrid === grid) desktopGalleryScrollGrid = null;
    }

    grid.mdcDesktopScrollController = controller;
    grid.mdcDesktopScrollCleanup = cleanup;
    desktopGalleryScrollGrid = grid;
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(refresh);
      observer.observe(media);
      observer.observe(root);
      var header = document.querySelector('#header-component');
      if (header) observer.observe(header);
    }
    window.addEventListener('resize', refresh);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
    refresh();
  }

  function updateReferenceFinishNote() {
    var bar = document.querySelector('sticky-add-to-cart[data-product-id="12619310137662"]');
    if (!bar) return;
    var root = productRoot();
    var field = root && root.querySelector('input[name="id"]');
    var variant = field ? field.value : bar.dataset.currentVariantId;
    var media = document.querySelector('main .product-information__media');
    if (!media) return;
    var note = media.querySelector('[data-mdc-reference-finish-note]');
    if (variant !== '54501279662398' && variant !== '54501279695166') {
      if (note) note.remove();
      return;
    }
    if (!note) {
      note = document.createElement('p');
      note.className = 'mdc-reference-finish-note';
      note.setAttribute('data-mdc-reference-finish-note', '');
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      media.appendChild(note);
    }
    var messages = {
      fr: 'Photos du modèle en noir et argenté. La finition Rose sélectionnée n’est pas illustrée.',
      en: 'Model shown in black and silver. The selected pink finish is not pictured.',
      es: 'Modelo mostrado en negro y plateado. El acabado rosa seleccionado no está ilustrado.',
      ar: 'الصور تعرض الموديل باللونين الأسود والفضي. اللون الوردي المحدد غير معروض.'
    };
    var text = messages[mdcLanguage] || messages.fr;
    if (note.textContent !== text) note.textContent = text;
  }

  function refreshGalleries() {
    var root = productRoot();
    var content = directContent(root);
    if (content) {
      positionMobileInformation(content, content.querySelector(':scope > .mdc-z-heading'), content.querySelector(':scope > .mdc-z-buy'));
    }
    updateReferenceFinishNote();
    bindMobileGallery();
    configureDesktopGalleryScroll(root);
  }

  function bindGalleryLifecycle(root) {
    var section = root && root.closest('.product-information');
    if (!section || section.dataset.mdcZGalleryLifecycle === 'true') return;
    section.dataset.mdcZGalleryLifecycle = 'true';
    var timer = 0;

    new MutationObserver(function (mutations) {
      var galleryChanged = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return false;
          return node.matches('media-gallery, slideshow-slides, slideshow-controls, .slideshow-controls__thumbnails, .product-details') ||
            node.querySelector('media-gallery, slideshow-slides, slideshow-controls, .slideshow-controls__thumbnails, .product-details');
        });
      });
      if (!galleryChanged) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(refreshGalleries, 40);
    }).observe(section, { childList: true, subtree: true });
  }

  function bindVariantRefresh() {
    if (document.documentElement.dataset.mdcZVariantRefresh === 'true') return;
    document.documentElement.dataset.mdcZVariantRefresh = 'true';
    document.addEventListener('change', function (event) {
      var variant = event.target.closest && event.target.closest('variant-picker');
      if (!variant || !event.target.matches('input, select')) return;
      window.setTimeout(refreshGalleries, 60);
      window.setTimeout(refreshGalleries, 500);
    });
  }

  function arrange() {
    var root = productRoot();
    var content = directContent(root);
    if (!root || !content) return;

    document.body.classList.add('mdc-maison-douce-product-top');
    root.classList.add('mdc-z-product-root');
    // Keep the existing chat available outside the purchase panel; an open chat stays usable.
    if (!root.dataset.mdcChatObserved && 'IntersectionObserver' in window) {
      root.dataset.mdcChatObserved = 'true';
      new IntersectionObserver(function (entries) {
        document.body.classList.toggle('mdc-pdp-reading', entries[0].isIntersecting);
      }).observe(root);
    }

    var children = directChildren(content);
    var header = children.find(function (child) { return child.querySelector && child.querySelector('h1'); });
    var customPromo = children.find(function (child) {
      return child.querySelector && child.querySelector('.promo-alarm');
    });
    var customReviews = children.find(function (child) {
      return child.querySelector && child.querySelector('.custom-trustpilot-line');
    });
    var divider = children.find(function (child) { return child.classList && child.classList.contains('divider'); });
    var variant = children.find(function (child) { return child.tagName && child.tagName.toLowerCase() === 'variant-picker'; });
    var buy = children.find(function (child) { return child.classList && child.classList.contains('buy-buttons-block'); });
    if (!header || !buy) return;

    header.classList.add('mdc-z-heading');
    if (customPromo) customPromo.classList.add('mdc-z-custom-promo');
    // Do not present static Trustpilot-style content as a verified customer review.
    // Verified review data must be supplied by a connected review provider instead.
    if (customReviews) customReviews.remove();
    if (divider) divider.classList.add('mdc-z-divider');
    if (variant) variant.classList.add('mdc-z-variants');
    buy.classList.add('mdc-z-buy');

    var accordions = normalizeAccordions(content, buy);
    configureIntegratedLed(accordions);
    populateBenefits(content, accordions, variant, buy);

    adaptPlaidPresentation();
    buildPromo(content, header);
    var gift = buildGift(content, buy);
    enhanceTrust(buy);
    bindGalleryLifecycle(root);
    refreshGalleries();
    bindVariantRefresh();

  }

  function initialize() {
    arrange();
    if (!productRoot()) window.setTimeout(arrange, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();

  mobileInformationQuery.addEventListener('change', refreshGalleries);
  document.addEventListener('shopify:section:load', arrange);
  window.addEventListener('pageshow', arrange);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') arrange();
  });
})();








